<template>
  <div>
    <b-container>
      <survey />
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Survey from "@/components/forms/survey";

export default {
  name: "Shelf",
  components: {
    Survey
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      profile: "user/profile"
    })
  },
  data() {
    return {
      loading: false,
      completed: false
    };
  },
  methods: {}
};
</script>

<style lang="css" scoped></style>
